import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResourceService, OcInfraModule, APICallerService, Configuration } from '@diaas/ux-web';
import { CommonService } from '../../services/common.service';
import { AdvGrowlService } from 'primeng-advanced-growl';
import { ToasterService } from 'angular2-toaster';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import * as _ from 'lodash';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../format-datepicker';


@Component({
  selector: 'app-billingupdate',
  templateUrl: './billingupdate.component.html',
  styleUrls: ['./billingupdate.component.scss'],
  providers: [
        {provide: DateAdapter, useClass: AppDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
  ]
})
export class BillingupdateComponent implements OnInit {

  editBillingForm = new FormGroup({
    billingMethod: new FormControl(null, [Validators.required]),
    effectiveDate: new FormControl(null, [Validators.required]),
    billingFrequency: new FormControl(null, [Validators.required]),
    totalPremiumPaid: new FormControl(null),
    AnnualPremiumPaid: new FormControl(null),
    modalPremiumPaid: new FormControl(null,[Validators.required]),
    paymentDueDate: new FormControl(null,[Validators.required]),
    billExtractDate: new FormControl({disabled: true})
  })
  updateBankForm = new FormGroup({
    bankEffectiveDate: new FormControl(null, [Validators.required]),
    accountType: new FormControl(null,Validators.required),
    accountHolderName: new FormControl(null,Validators.required),
    bankName: new FormControl(null,Validators.required),
    accountNumber: new FormControl(null,Validators.required),
    retypeAccountNumber: new FormControl(null,Validators.required),
    routingNumber: new FormControl(null,Validators.required),
  })
  transferFrequency: any;
  addressResponse: any;
  addressResponseProperties: any;
  billingMethod: any[];
  billingFrequency: any[];
  isPAC: boolean = false;
  accountType: any[];
  disableGetBankInfo: boolean = false;
  hoverMessageeditBilling: string = '';
  hoverMessage: string = '';
  retypeAccountNumberValidation: boolean = false;
  getBankInfoResponse: any;
  getbankinfoClicked: boolean = false;
  previousRoutingValue: any = '';
  previousValue: any;
  buttonDisabled: boolean;
  isUL: boolean = false;
  isPaymentDueDateRequired: boolean = true;

  constructor(private toasterService: ToasterService, private datePipe: DatePipe) { }

  ngOnInit() {
    this.editBillingForm.valueChanges.subscribe(changes => {
      if(!this.editBillingForm.valid) {
      this.hoverMessageeditBilling = 'Enable button by completing required items';
    } else {
      this.hoverMessageeditBilling = '';
    }
    });
    this.updateBankForm.valueChanges.subscribe(changes => {
      if(!(this.updateBankForm.valid && this.getbankinfoClicked)) {
      this.hoverMessage = 'Enable button by completing required items';
    } else {
      this.hoverMessage = '';
    }
    });
    this.updateBankForm.controls['routingNumber'].valueChanges.subscribe(currentValue => {
      const isValidLength = currentValue.length === 9;
      const isDifferent = currentValue !== this.previousValue;

      if (isValidLength) {
        this.disableGetBankInfo = false;
        this.getbankinfoClicked = false;
      } else {
        this.disableGetBankInfo = true;
        this.getbankinfoClicked = true;
      }
    });
    if(!this.updateBankForm.valid) {
      this.hoverMessage = 'Enable button by completing required items';
    }
    const resourceService = OcInfraModule.AppInjector.get(ResourceService);
    this.addressResponse = resourceService.getResourceFromAliasName('billingInfo') ? resourceService.getResourceFromAliasName('billingInfo').response : null;
    this.addressResponseProperties = this.addressResponse._options;
    //effectiveDate: [new Date(this.addressResponse.effective_date)];
    this.isPAC = (this.addressResponse.bill_option ? this.addressResponse.bill_option == 'P'? true : false : false);
    if(this.addressResponse.transit_number.length == '9') {
      this.disableGetBankInfo = false;
    } else {
      this.disableGetBankInfo = true;
    }
    this.getBillingDetails();
    this.getBankdetails();
    let details = OcInfraModule.AppInjector.get(ResourceService).getResourceFromAliasName('policyDetails');
    if (details.data.product_type.includes('U')) {
      this.isUL = true;
    }
    else {
      this.editBillingForm.controls['modalPremiumPaid'].disable();
      this.isUL = false;
    }   
  }

  getBillingDetails() {
    //billing method
    this.billingMethod = [];
      if (this.addressResponseProperties && this.addressResponseProperties.properties && this.addressResponseProperties.properties.bill_option.oneOf) {
        for (let i = 0; i < this.addressResponseProperties.properties.bill_option.oneOf.length; i++) {
          this.billingMethod.push({ value: this.addressResponseProperties.properties.bill_option.oneOf[i].title, viewValue: this.addressResponseProperties.properties.bill_option.oneOf[i].title });
        }
      }
    if (this.addressResponse.bill_option) {
          const defaultBillingMethod = this.addressResponseProperties.properties.bill_option.oneOf.find(opt => opt.enum.includes(this.addressResponse.bill_option.toString()));
          defaultBillingMethod ? this.editBillingForm.controls['billingMethod'].setValue(defaultBillingMethod.title) : this.editBillingForm.controls['billingMethod'].setValue('');
        }

    //billing frequncy
    this.billingFrequency = [];
      if (this.addressResponseProperties && this.addressResponseProperties.properties && this.addressResponseProperties.properties.billing_frequency.oneOf) {
        for (let i = 0; i < this.addressResponseProperties.properties.billing_frequency.oneOf.length; i++) {
          this.billingFrequency.push({ value: this.addressResponseProperties.properties.billing_frequency.oneOf[i].enum[0], viewValue: this.addressResponseProperties.properties.billing_frequency.oneOf[i].title });
        }
      }
    if (this.addressResponse.billing_frequency) {
          const defaultBillingFrequency = this.addressResponseProperties.properties.billing_frequency.oneOf.find(opt => opt.enum.includes(this.addressResponse.billing_frequency.toString()));
          defaultBillingFrequency ? this.editBillingForm.controls['billingFrequency'].setValue(defaultBillingFrequency.enum[0]) : this.editBillingForm.controls['billingFrequency'].setValue('');
        }
    const resourceService = OcInfraModule.AppInjector.get(ResourceService);
    let policyDetails = resourceService.getResourceFromAliasName('policyDetails');
  

    //total premium paid
    this.editBillingForm.controls['totalPremiumPaid'].setValue('$'+policyDetails.response.total_premium_paid);
    this.editBillingForm.controls['totalPremiumPaid'].disable();
    //annual premium
    this.editBillingForm.controls['AnnualPremiumPaid'].setValue('$'+this.addressResponse.total_annual_mode_premium);
    this.editBillingForm.controls['AnnualPremiumPaid'].disable();
    //modal premium
    this.editBillingForm.controls['modalPremiumPaid'].setValue(this.formatCurrency('','blur',this.addressResponse.modal_premium));
    //effectiveDate
    this.editBillingForm.controls['effectiveDate'].setValue(this.addressResponse.effective_date ? new Date(this.addressResponse.effective_date) : null);
    //payment due date
    this.editBillingForm.controls['paymentDueDate'].setValue(this.addressResponse.payment_due_date ? new Date(this.addressResponse.payment_due_date) : null);
    //bill extract date
    this.editBillingForm.controls['billExtractDate'].setValue(this.addressResponse.billing_extract_date ? new Date(this.addressResponse.billing_extract_date) : null);
    this.editBillingForm.controls['billExtractDate'].disable();
  }

  getBankdetails() {
    //effective date
    this.updateBankForm.controls['bankEffectiveDate'].setValue(this.addressResponse.effective_date ? new Date(this.addressResponse.effective_date) : null);
    //account type
    this.accountType = [];
      if (this.addressResponseProperties && this.addressResponseProperties.properties && this.addressResponseProperties.properties.account_type.oneOf) {
        for (let i = 0; i < this.addressResponseProperties.properties.account_type.oneOf.length; i++) {
          this.accountType.push({ value: this.addressResponseProperties.properties.account_type.oneOf[i].title, viewValue: this.addressResponseProperties.properties.account_type.oneOf[i].title });
        }
      }
    if (this.addressResponse.account_type) {
          const defaultaccountType = this.addressResponseProperties.properties.account_type.oneOf.find(opt => opt.enum.includes(this.addressResponse.account_type.toString()));
          defaultaccountType ? this.updateBankForm.controls['accountType'].setValue(defaultaccountType.title) : this.updateBankForm.controls['accountType'].setValue('');
        }
    //account holder name
    this.updateBankForm.controls['accountHolderName'].setValue(this.addressResponse.account_holder_name);
    //bank name
    this.updateBankForm.controls['bankName'].setValue(this.addressResponse.bank_name);
    this.updateBankForm.controls['bankName'].disable();
    //account number
    this.updateBankForm.controls['accountNumber'].setValue(this.addressResponse.account_number);
    //routing number
    this.updateBankForm.controls['routingNumber'].setValue(this.addressResponse.transit_number); 
  }
  

  onSubmit() {
    console.log("success");
  }

  onBillingMethodChange(e) {
    let updatedBillingMethod = e.value;
    if(updatedBillingMethod == 'P - PAC') {
      this.isPAC = true;
    } else {
      this.isPAC = false;
    }

    if(updatedBillingMethod == 'N - No Bill' && this.isUL) {
      this.editBillingForm.controls['billingFrequency'].setValue('0');
      this.editBillingForm.controls['billingFrequency'].disable();
      this.editBillingForm.controls['modalPremiumPaid'].setValue('$0.00');
      this.editBillingForm.controls['paymentDueDate'].disable();
      this.editBillingForm.controls['billExtractDate'].disable();
      this.editBillingForm.controls['paymentDueDate'].setValue('');
      this.editBillingForm.controls['billExtractDate'].setValue('');
      this.editBillingForm.controls['modalPremiumPaid'].disable();
      this.editBillingForm.controls['paymentDueDate'].setValidators(null);
      this.isPaymentDueDateRequired = false;
    } else if(this.isUL && updatedBillingMethod != 'N - No Bill')  {
      this.editBillingForm.controls['paymentDueDate'].setValidators(Validators.required);
      this.editBillingForm.controls['paymentDueDate'].enable();
      this.editBillingForm.controls['billExtractDate'].enable();
      this.editBillingForm.controls['billingFrequency'].enable();
      this.editBillingForm.controls['modalPremiumPaid'].enable();
      this.isPaymentDueDateRequired = true;
    }
  }

  getbankInfo() {
    const resourceService = OcInfraModule.AppInjector.get(ResourceService);
    let policyDetails = resourceService.getResourceFromAliasName('policyDetails');
    let url = policyDetails.response._links.billing.href;
    let accountType = (this.updateBankForm.controls['accountType'].value).split('-')[0];
    let routingNumber = this.updateBankForm.controls['routingNumber'].value;
    let bankinfoUrl = url+"/bankname?routingNumber="+`${routingNumber}`+"&accountType="+`${accountType}`;
    let header = _.filter(Configuration.config.headers.multiHostUrlHeader, function (o) { return o.alias == 'billingInfo' });
    header[0]['headers']['role'] = OcInfraModule.AppInjector.get(CommonService).selectedRole;
    OcInfraModule.AppInjector.get(CommonService).getCallback(bankinfoUrl, header[0]['headers']).subscribe(getbankInfoResponse => {
      this.previousValue = this.updateBankForm.controls['routingNumber'].value;
      this.toasterService.clear();
      this.getBankInfoResponse = getbankInfoResponse;
      this.getbankinfoClicked = true;
      this.updateBankForm.controls['bankName'].setValue(getbankInfoResponse.bank_name);
    }, error => {
        this.toasterService.clear();
        this.displayAlerts(error, "error");
        this.getbankinfoClicked = false;
        this.updateBankForm.controls['bankName'].setValue('');
    });
  }

  displayAlerts(response, type) {
    if ( response._embedded && response._embedded.status_report && response._embedded.status_report.messages && response._embedded.status_report.messages.length > 0) {
      let fillteredData =response._embedded.status_report.messages.filter(x=>x.message !== "No mapping rule matched");
      fillteredData.forEach(element => {
        let alertMsg = {
          title: element.severity,
          type: type,
          body: element.message,
          showCloseButton: true,
          timeout: 0,
          tapToDismiss: false,
        }
        this.toasterService.pop(alertMsg);
      });
    }
  }

  validateReenterNumbers() {
    let accountNumber= this.updateBankForm.controls['accountNumber'].value;
    let reenterAccountNumber= this.updateBankForm.controls['retypeAccountNumber'].value;
    let transitNumber= this.updateBankForm.controls['routingNumber'].value;
    if(accountNumber != '' && reenterAccountNumber != '' && (accountNumber ==reenterAccountNumber)) {
      const resourceService = OcInfraModule.AppInjector.get(ResourceService);
              const workRequestHref = resourceService.getHrefByAliasName("workRequestHistory");
              let header = _.filter(Configuration.config.headers["multiHostUrlHeader"], function (o) { return o.alias == 'workRequestHistory' });
                  const authResponse = resourceService.getResourceFromAliasName('authRes');
                  const selectedRoleSummary = resourceService.getResourceFromAliasName('selectedRoles');
                  let policyDetails = resourceService.getResourceFromAliasName('policyDetails');
                  //const modalProperties = params.modal.renderer.data.sections[0].properties
                  let payloadData = {};
                  let payload = {
                      "CLTY": "MANEFT",
                      "hostKey": selectedRoleSummary && selectedRoleSummary.data.hostKey ? selectedRoleSummary.data.hostKey : '',
                      "sessionId": authResponse && authResponse.data.contactSessionID ? authResponse.data.contactSessionID : '',
                      "callStart": authResponse && authResponse.data.callStart ? authResponse.data.callStart : '',
                      "type": "Billing Change Request",
                      "clientId": selectedRoleSummary && selectedRoleSummary.data.clientId ? selectedRoleSummary.data.clientId : '',
                      "userId": OcInfraModule.AppInjector.get(CommonService).incontactId,
                      "policyNumber": policyDetails && policyDetails.data && policyDetails.data.policy_number?policyDetails.data.policy_number:'',
                      "bill_option": this.addressResponse.bill_option,
                      "modal_premium": this.addressResponse.modal_premium,
                      "payment_due_date": this.addressResponse.payment_due_date,
                      "bill_extract_date": this.addressResponse.billing_extract_date,
                      //"total_premium_paid": this.editBillingForm.controls['totalPremiumPaid'].value.replace('$',''),
                      //"annual_premium_paid": this.editBillingForm.controls['AnnualPremiumPaid'].value.replace('$',''),
                      "billing_frequency": this.addressResponse.billing_frequency,
                      "effective_date": this.addressResponse.effective_date,
                      'company_code': header[0].headers.company_code,
                      'region_code': header[0].headers.region_code,
                      'remote_user': header[0].headers.remote_user,
                      "account_number" : this.updateBankForm.controls['accountNumber'].value,
                      "account_type" : this.updateBankForm.controls['accountType'].value.split('-')[0],
                      "bank_name" : this.updateBankForm.controls['bankName'].value,
                      "transit_number" : this.updateBankForm.controls['routingNumber'].value,
                      "eft_id" : "0"
                  }
  
                  payload.effective_date = OcInfraModule.AppInjector.get(CommonService).formatDate(payload.effective_date);
                  payload.payment_due_date = OcInfraModule.AppInjector.get(CommonService).formatDate(payload.payment_due_date);
                  payload.bill_extract_date = OcInfraModule.AppInjector.get(CommonService).formatDate(payload.bill_extract_date);
                  const url = OcInfraModule.AppInjector.get(CommonService).billingPatchHref;
                  header[0].headers.role = OcInfraModule.AppInjector.get(CommonService).selectedRole;
                  OcInfraModule.AppInjector.get(APICallerService).changeHeaders(header[0].headers);
                  OcInfraModule.AppInjector.get(CommonService).showHideSpinner({ showSpinner: true, edit: true })
                  OcInfraModule.AppInjector.get(APICallerService).patch(url, payload).subscribe(response => {
                      OcInfraModule.AppInjector.get(CommonService).billing = false;
                      OcInfraModule.AppInjector.get(APICallerService).refresh(url, { 'alias': "billingInfo", 'headers': header[0].headers }).subscribe(refreshResponse => { });
                      OcInfraModule.AppInjector.get(APICallerService).refresh(workRequestHref, { 'alias': "workRequestHistory", 'headers': header[0].headers }).subscribe(refreshResponse => {
                          OcInfraModule.AppInjector.get(CommonService).wrkReqHistoryRes = refreshResponse;
                          OcInfraModule.AppInjector.get(CommonService).sendFilterEvent();
                      });
                      OcInfraModule.AppInjector.get(AdvGrowlService).createSuccessMessage('Work Item Successful: EFT Request', 'Success');
                      document.getElementById("modal__cross").click();
                  },
                      error => {
                          OcInfraModule.AppInjector.get(APICallerService).refresh(workRequestHref, { 'alias': "workRequestHistory", 'headers': header[0].headers }).subscribe(refreshResponse => {
                              OcInfraModule.AppInjector.get(CommonService).wrkReqHistoryRes = refreshResponse;
                              OcInfraModule.AppInjector.get(CommonService).sendFilterEvent();
                          });
                        }
                      )
    } else {
      this.updateBankForm.controls['retypeAccountNumber'].setValue('');
      let alertMsg = [];
      let popUpMsg = "Bank Account numbers entered do not match. Please enter the same data in both fields to validate EFT setup.";
      alertMsg.push(popUpMsg);
      //alertMsg.push(customerResults[0].summary.contactLabel1 ? customerResults[0].summary.contactLabel1 + ": " + customerResults[0].summary.contactNumber1 : '', customerResults[0].summary.contactLabel2 ? customerResults[0].summary.contactLabel2 + ": " + customerResults[0].summary.contactNumber2 : '', customerResults[0].summary.contactLabel3 ? customerResults[0].summary.contactLabel3 + ": " + customerResults[0].summary.contactNumber3 : '');
      let dialogRef = OcInfraModule.AppInjector.get(CommonService).showConfirmation({ content: alertMsg, custom: true }, 'CLOSE', '', 'ALERT', '393px');
      dialogRef.afterClosed().subscribe(res => {
          res;
        });
    }
  }

  restrictInput(e) {
    const regex = /^[0-9]$/; 
    // Get the pressed key
    const key = e.key;

    if (!regex.test(key) && key !== 'Backspace' && key !== 'Delete') {
      e.preventDefault();
    }
  }

  updateBilling() {
          OcInfraModule.AppInjector.get(AdvGrowlService).clearMessages();
          let billingmode = this.editBillingForm.controls['billingMethod'].value.split('-')[0].replace(' ','');
          if(billingmode != 'P'){
          let msg = 'Changing the Billing Method from PAC to another method will permanently remove the existing PAC Banking Information. Do you want to proceed?';
          let dialogRef = OcInfraModule.AppInjector.get(CommonService).showConfirmation(msg, 'CANCEL', 'YES')
          dialogRef.afterClosed().subscribe(res => {
            this.updateBillingPatch(res);
          });
        } else {
          this.updateBillingPatch(true);
        }
      }

    updateBillingPatch(res) {
      const resourceService = OcInfraModule.AppInjector.get(ResourceService);
              const workRequestHref = resourceService.getHrefByAliasName("workRequestHistory");
              let policyDetails = resourceService.getResourceFromAliasName("policyDetails");
              let header = _.filter(Configuration.config.headers["multiHostUrlHeader"], function (o) { return o.alias == 'workRequestHistory' });
              if(res) {    
              const authResponse = resourceService.getResourceFromAliasName('authRes');
                  const selectedRoleSummary = resourceService.getResourceFromAliasName('selectedRoles');
                  //const modalProperties = params.modal.renderer.data.sections[0].properties
                  let payloadData = {};
                  let payload = {
                      "CLTY": "MANEFT",
                      "hostKey": selectedRoleSummary && selectedRoleSummary.data.hostKey ? selectedRoleSummary.data.hostKey : '',
                      "sessionId": authResponse && authResponse.data.contactSessionID ? authResponse.data.contactSessionID : '',
                      "callStart": authResponse && authResponse.data.callStart ? authResponse.data.callStart : '',
                      "type": "Billing Change Request",
                      "clientId": selectedRoleSummary && selectedRoleSummary.data.clientId ? selectedRoleSummary.data.clientId : '',
                      "userId": OcInfraModule.AppInjector.get(CommonService).incontactId,
                      "policyNumber": policyDetails && policyDetails.data && policyDetails.data.policy_number?policyDetails.data.policy_number:'',
                      "bill_option": this.editBillingForm.controls['billingMethod'].value.split('-')[0].replace(' ',''),
                      "modal_premium": this.editBillingForm.controls['modalPremiumPaid'].value?this.editBillingForm.controls['modalPremiumPaid'].value.replace('$',''):'0.00',
                      "payment_due_date": this.editBillingForm.controls['paymentDueDate'].value?this.editBillingForm.controls['paymentDueDate'].value:this.addressResponse.payment_due_date,
                      "bill_extract_date": this.editBillingForm.controls['billExtractDate'].value?this.editBillingForm.controls['billExtractDate'].value:null,
                      //"total_premium_paid": this.editBillingForm.controls['totalPremiumPaid'].value.replace('$',''),
                      //"annual_premium_paid": this.editBillingForm.controls['AnnualPremiumPaid'].value.replace('$',''),
                      "billing_frequency": this.editBillingForm.controls['billingFrequency'].value.split('-')[0].replace(' ',''),
                      "effective_date": this.editBillingForm.controls['effectiveDate'].value?this.editBillingForm.controls['effectiveDate'].value:null,
                      'company_code': header[0].headers.company_code,
                      'region_code': header[0].headers.region_code,
                      'remote_user': header[0].headers.remote_user,
                  }
  
                  payload.effective_date ?payload.effective_date = OcInfraModule.AppInjector.get(CommonService).formatDate(payload.effective_date):null;
                  payload.payment_due_date ? payload.payment_due_date = OcInfraModule.AppInjector.get(CommonService).formatDate(payload.payment_due_date):null;
                  payload.bill_extract_date ? payload.bill_extract_date = OcInfraModule.AppInjector.get(CommonService).formatDate(payload.bill_extract_date):null;
                  const url = OcInfraModule.AppInjector.get(CommonService).billingPatchHref;
                  header[0].headers.role = OcInfraModule.AppInjector.get(CommonService).selectedRole;
                  OcInfraModule.AppInjector.get(APICallerService).changeHeaders(header[0].headers);
                  if((payload.modal_premium == '0.00' || payload.modal_premium == '0') && ((this.isUL && payload.bill_option != 'N'))) {
                    OcInfraModule.AppInjector.get(AdvGrowlService).createTimedErrorMessage("Modal Premium must be entered", 'Error', 0); 
                  } else {
                  OcInfraModule.AppInjector.get(CommonService).showHideSpinner({ showSpinner: true, edit: true })
                  OcInfraModule.AppInjector.get(APICallerService).patch(url, payload).subscribe(response => {
                      OcInfraModule.AppInjector.get(CommonService).billing = false;
                      OcInfraModule.AppInjector.get(APICallerService).refresh(url, { 'alias': "billingInfo", 'headers': header[0].headers }).subscribe(refreshResponse => { });
                      OcInfraModule.AppInjector.get(APICallerService).refresh(workRequestHref, { 'alias': "workRequestHistory", 'headers': header[0].headers }).subscribe(refreshResponse => {
                        this.toasterService.clear();
                          OcInfraModule.AppInjector.get(CommonService).wrkReqHistoryRes = refreshResponse;
                          OcInfraModule.AppInjector.get(CommonService).sendFilterEvent();
                      });
                      OcInfraModule.AppInjector.get(AdvGrowlService).createSuccessMessage('Work Item Successful: EFT Request', 'Success');
                      document.getElementById("modal__cross").click();
                  },
                      error => {
                          //this.displayAlerts(error.error,'error');
                          OcInfraModule.AppInjector.get(APICallerService).refresh(workRequestHref, { 'alias': "workRequestHistory", 'headers': header[0].headers }).subscribe(refreshResponse => {
                              OcInfraModule.AppInjector.get(CommonService).wrkReqHistoryRes = refreshResponse;
                              OcInfraModule.AppInjector.get(CommonService).sendFilterEvent();
                          });
                      }
                  )
                }
              }
    }

    routingValueChange(e) {
      let value = e.target.value;
      if(value.length == '9' && value != this.previousRoutingValue) {
        this.disableGetBankInfo = false;
        this.getbankinfoClicked = false;
        this.hoverMessage = 'Enable button by completing required items';
      } else {
        this.disableGetBankInfo = true;
        this.getbankinfoClicked = true;
      }
      this.previousRoutingValue = value;
    }

    modalPremiumEvent(event) {
      let modalPremiumValue = event.target.value;
      event.target.value = this.formatCurrency('', 'blur', modalPremiumValue);
    }

  formatCurrency(input, blur, respValue) {
        var input_val = "";
        if (respValue == '' || respValue == undefined) {
            input_val = input.target.value;
        } else {
            input_val = respValue;
        }
        if (input_val === "") { return; }
        var original_len = input_val.length;
        if (input_val.indexOf(".") >= 0) {
            var decimal_pos = input_val.indexOf(".");
            decimal_pos = decimal_pos > 15 ? 15 : decimal_pos;
            var left_side = input_val.substring(0, decimal_pos);
            var right_side = input_val.substring(decimal_pos);
            left_side = this.formatNumber(left_side, 'currency', true);
            right_side = this.formatNumber(right_side, 'currency', false);
            if (blur === "blur") {
                right_side += "00";
            }
            // Limit decimal to only 2 digits
            right_side = right_side.substring(0, 2);
            // join number by .
            input_val = "$" + left_side + "." + right_side;

        } else {
            // no decimal entered
            // add commas to number
            // remove all non-digits
            input_val = input_val.substring(0, 15);
            input_val = this.formatNumber(input_val, 'currency', true);
            input_val = "$" + input_val;
            // final formatting
            if (blur === "blur") {
                input_val += ".00";
            }
        }
        if (input_val.charAt(input_val.indexOf('$') + 1) == '.') {
            input_val = input_val.replace(input_val.charAt(input_val.indexOf('$') + 1), '0.');
        }
        if (respValue == '' || respValue == undefined) {
            input.target["value"] = input_val;
        } else {
            return input_val;
        }
    }

    formatNumber(n, type, flag) {
        if (flag) {
            n = n.charAt(0) == '0' ? n.replace(n.charAt(0), "") : n;
        }
        if (type == 'currency') {
            return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return n.replace(/\D/g, "");
        }
    }
    

}
